import { render, staticRenderFns } from "./valueDesc.vue?vue&type=template&id=8a113a2a&scoped=true"
import script from "./valueDesc.vue?vue&type=script&lang=js"
export * from "./valueDesc.vue?vue&type=script&lang=js"
import style0 from "./valueDesc.vue?vue&type=style&index=0&id=8a113a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a113a2a",
  null
  
)

export default component.exports